import { c as e } from "react/compiler-runtime";
import { useEffect as t, useRef as n, useState as r } from "react";
//#region src/hooks/useOverflowTooltip.tsx
var i = () => {
	let i = e(7), o = n(null), [s, c] = r(!1), l = a, u;
	i[0] === Symbol.for("react.memo_cache_sentinel") ? (u = () => {
		c(l(o));
	}, i[0] = u) : u = i[0];
	let d;
	i[1] === s ? d = i[2] : (d = [s, l], i[1] = s, i[2] = d), t(u, d);
	let f, p;
	i[3] === Symbol.for("react.memo_cache_sentinel") ? (f = () => {
		let e = new ResizeObserver(() => {
			c(l(o));
		});
		o.current && e.observe(o.current);
		let t = o.current;
		return () => {
			t && e.unobserve(t);
		};
	}, p = [l], i[3] = f, i[4] = p) : (f = i[3], p = i[4]), t(f, p);
	let m;
	return i[5] === s ? m = i[6] : (m = [o, s], i[5] = s, i[6] = m), m;
};
function a(e) {
	return e !== null && e.current ? e.current.offsetWidth < e.current.scrollWidth : !1;
}
//#endregion
export { i as useOverflowTooltip };
